/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitTransferAddSourceFundViewModel
 */
export interface UnitTransferAddSourceFundViewModel {
    /**
     * 
     * @type {number}
     * @memberof UnitTransferAddSourceFundViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitTransferAddSourceFundViewModel
     */
    fundCode: number;
    /**
     * 
     * @type {number}
     * @memberof UnitTransferAddSourceFundViewModel
     */
    allocationAmount?: number;
}

/**
 * Check if a given object implements the UnitTransferAddSourceFundViewModel interface.
 */
export function instanceOfUnitTransferAddSourceFundViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundCode" in value;

    return isInstance;
}

export function UnitTransferAddSourceFundViewModelFromJSON(json: any): UnitTransferAddSourceFundViewModel {
    return UnitTransferAddSourceFundViewModelFromJSONTyped(json, false);
}

export function UnitTransferAddSourceFundViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitTransferAddSourceFundViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'fundCode': json['FundCode'],
        'allocationAmount': !exists(json, 'AllocationAmount') ? undefined : json['AllocationAmount'],
    };
}

export function UnitTransferAddSourceFundViewModelToJSON(value?: UnitTransferAddSourceFundViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'FundCode': value.fundCode,
        'AllocationAmount': value.allocationAmount,
    };
}

